module.exports = __webpack_public_path__ + "static/media/sumitomo_mitsui_banking_corp.46ce4ee7.svg";